import React, { useState } from 'react';
import 'twin.macro';
import { Button } from '../button';
import { Input } from './FormParticals';
import { Icon } from '../icon';
import { LoaderIcon } from 'icons';
import { userResetPassword } from 'services/user';
import { Notification } from '../notifications';
import { useUnmounted } from '../common/hooks';
import { Small } from '../text';
export const SUBMIT_RESET_SUCCESS_MESSAGE =
  'Je wachtwoord is aangepast. Je kan nu inloggen met je nieuwe wachtwoord.';
export const SUBMIT_RESET_ERROR_MESSAGE = 'Er gaat iets fout... probeer het nog eens';

export const TogglePasswordButton = ({ ...props }) => <Button {...props} />;
export const SubmitButton = ({ ...props }) => <Button {...props} />;

export const ResetPasswordForm = ({ token }) => {
  const unmounted = useUnmounted();
  const [password, setPassword] = useState('');
  const [passwordCheck, setPasswordCheck] = useState('');
  const [pending, setPending] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [notification, setNotification] = useState({});

  const submit = (e) => {
    e.preventDefault();
    setPending(true);
    setNotification({});

    userResetPassword({
      password,
      token,
    })
      .then(() => {
        if (!unmounted.current) {
          setPassword('');
          setPending(false);
          setNotification({ state: 'success', message: SUBMIT_RESET_SUCCESS_MESSAGE });
        }
      })
      .catch((e) => {
        if (!unmounted.current) {
          const error =
            e.response && e.response.data.errors
              ? e.response.data.errors[0].Message
              : SUBMIT_RESET_ERROR_MESSAGE;
          setPending(false);
          setNotification({ state: 'error', message: error });
        }
      });
  };

  return (
    <>
      {notification.state && (
        <Notification
          message={notification.message}
          style={notification.state}
          onClick={() => setNotification({})}
          tw='mb-4'
        />
      )}
      <div tw='mb-4'>
        <Small>Een wachtwoord moet tussen de 6 en 20 tekens bevatten.</Small>
      </div>
      <form onSubmit={submit}>
        <Input
          placeholder='Nieuw wachtwoord'
          name='password'
          id='password'
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          requiredField
          label={password ? 'Nieuw wachtwoord' : ''}
        />
        <Input
          placeholder='Herhaal wachtwoord'
          name='passwordcheck'
          id='passwordcheck'
          type={showPassword ? 'text' : 'password'}
          value={passwordCheck}
          onChange={(e) => setPasswordCheck(e.target.value)}
          requiredField
          label={passwordCheck ? 'herhaal wachtwoord' : ''}
        />
        {password !== '' &&
          passwordCheck !== '' &&
          passwordCheck.length >= password.length &&
          password !== passwordCheck && (
            <Small tw='block text-danger mb-4 opacity-100'>Wachtwoord komt niet overeen.</Small>
          )}
        {password !== '' &&
          passwordCheck !== '' &&
          passwordCheck.length === password.length &&
          password === passwordCheck && (
            <Small tw='block text-brand mb-4 opacity-100'>Wachtwoorden komen overeen.</Small>
          )}
        <div tw='flex justify-center gap-4'>
          <TogglePasswordButton
            label={`Wachtwoord ${showPassword ? 'verbergen' : 'tonen'}`}
            ghost
            onClick={() => setShowPassword(!showPassword)}
          />

          <SubmitButton
            type='submit'
            label={
              !pending ? (
                'Wachtwoord wijzigen'
              ) : (
                <Icon Type={LoaderIcon} tw='animate-spin h-5' color='input-back' size='small' />
              )
            }
            primary
            disabled={
              pending || (password === '' && passwordCheck === '') || password !== passwordCheck
            }
          />
        </div>
      </form>
    </>
  );
};
